module.exports = __webpack_public_path__ + "img/drag-block.1bdd9e1a.svg";